/*eslint import/namespace: ['error', { allowComputed: true }]*/
import { icons } from "lucide-react";

import { cn } from "~/utils";

interface IconProps {
  name: keyof typeof icons;
  color?: string;
  size?: number;
  className?: string;
}

export const Icon = ({ name, color, size, className }: IconProps) => {
  const LucideIcon = icons[name];

  return <LucideIcon color={color} size={size} className={cn(className)} />;
};

export const SpinnerIcon = ({ className }: { className?: string }) => {
  return (
    // 2/3 circle
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M23 9V15H22V17H21V19H20V20H19V21H17V22H15L15 23H9L9 22H7V21H5L5 20H4V19H3L3 17H2L2 15H1L1 9H2L2 7L4 7V9H3L3 15H4V17H5V19H7L7 20H9V21H15V20H17V19H19V17H20V15H21V9H20V7H19V5H17V4H15V3H12V1H15V2H17V3H19V4H20V5H21V7H22V9H23Z"
        fill="currentColor"
      />
    </svg>
  );
};
